import type { InvoiceOfferPaymentMetaWire } from '@klear/invoice-offer/invoice-offer.wire'
import { invoiceOfferFunderOrganizationId } from '@klear/invoice-offer/list-display'
import { Money } from '@klear/money'

export interface FundingRollupOffer {
  canReturnAdvance: boolean
  currency?: string | null
  purchasePrice: Money
  paymentMeta?: InvoiceOfferPaymentMetaWire | undefined
  fundingSpvLabel?: string | undefined
}

export interface FundingSpvSummary {
  organizationId: number
  spvName: string
  offerCount: number
  totalPurchasePrice: Money
}

export function buildSpvSummaries(
  offers: FundingRollupOffer[],
  { exposureOnly = false }: { exposureOnly?: boolean } = {}
): FundingSpvSummary[] {
  const byOrgAndCurrency = new Map<string, FundingSpvSummary>()

  for (const offer of offers) {
    if (exposureOnly && !offer.canReturnAdvance) continue

    const purchasePrice = offer.purchasePrice
    const organizationId = invoiceOfferFunderOrganizationId(offer.paymentMeta) ?? 0
    const orgKey = organizationId > 0 ? organizationId : -1
    const mapKey = `${orgKey}:${purchasePrice.currency}`
    const spvName = offer.fundingSpvLabel?.trim() || '—'
    const existing = byOrgAndCurrency.get(mapKey)

    if (existing) {
      existing.offerCount += 1
      existing.totalPurchasePrice = existing.totalPurchasePrice.add(purchasePrice)
    } else {
      byOrgAndCurrency.set(mapKey, {
        organizationId,
        spvName,
        offerCount: 1,
        totalPurchasePrice: purchasePrice
      })
    }
  }

  return [...byOrgAndCurrency.values()].sort((a, b) => a.spvName.localeCompare(b.spvName))
}
